import type { EntryPoint } from 'repluggable';

import { A11yWizardDuplexerAPI } from '@wix/a11y-adapters/studio';
import { createA11yWizardDuplexerAPI } from './create-a11y-wizard-duplexer-api';
import { a11yWizardDuplexerReducer } from './store';
import type { A11yWizardDuplexerScopedState } from './store';

export const A11yWizardDuplexerAPIEntry: EntryPoint = {
  name: A11yWizardDuplexerAPI.name,
  layer: A11yWizardDuplexerAPI.layer,
  declareAPIs: () => [A11yWizardDuplexerAPI],

  attach: (shell) => {
    shell.contributeState<A11yWizardDuplexerScopedState>(() => ({
      a11yWizardDuplexerState: a11yWizardDuplexerReducer,
    }));
    shell.contributeAPI(A11yWizardDuplexerAPI, () =>
      createA11yWizardDuplexerAPI(shell),
    );
  },
};
